/**
 * The corner number to draw, or `undefined` when something else already sits
 * in the panel's top-left corner — a header, filter bar or stats bar — which
 * the triangle would paint over.
 */
export function visibleCornerNumber({
  cornerNumber,
  hasHeader,
  hasFilterBar,
  hasStatsBar,
}: {
  cornerNumber: number | undefined;
  hasHeader: boolean;
  hasFilterBar: boolean;
  hasStatsBar: boolean;
}): number | undefined {
  if (hasHeader || hasFilterBar || hasStatsBar) {
    return undefined;
  }
  return cornerNumber;
}
